const SEARCH_BASE_URL = 'https://cian.ru/cat.php';
const MODERATE_BASE_URL = 'https://service.cian.ru/moderate-announcements/index';

export function getModerateUrl(queryString: string): string {
  const searchUrl = `${SEARCH_BASE_URL}?${queryString}`;

  return (
    `${MODERATE_BASE_URL}?QueryStringFilter.DoNotUseOtherFilters=true` +
    `&QueryStringFilter.SearchURL=${encodeURIComponent(searchUrl)}`
  );
}
